export const SelectArrow = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M7.37041 7.83515L13.8001 1.20467C14.2013 0.790938 13.9581 0 13.4297 0H0.570303C0.0418882 0 -0.201306 0.790938 0.199896 1.20467L6.62959 7.83515C6.84274 8.05495 7.15726 8.05495 7.37041 7.83515Z" fill="#3F3F3F" />
    </svg>
  )
}
